import classNames from "classnames";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import styles from "../style.module.scss";

interface navItemInterface extends SideBarItemPathType {
  setIsOpen: (val: boolean) => void;
  isBlank?: boolean;
}

const NavItem = ({
  title,
  Icon,
  path,
  subPaths,
  isBlank,
  setIsOpen,
}: navItemInterface) => {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (path === location.pathname) {
      setActive(true);
    } else {
      setActive(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <Link
        className={classNames(
          theme === "dark" ? styles.darkNavIcon : styles.lightNavIcon,
          active ? styles.activeNavItemContainer : styles.navItemContainer,
          "w-full"
        )}
        target={isBlank ? "_blank" : ""}
        to={path ? path : ""}
        onClick={() => {
          setIsOpen(false);
        }}
      >
        {Icon ? (
          <img src={Icon} alt="" className={classNames(styles.icon)} />
        ) : null}

        <label className={classNames(styles.heading)} role="button">
          {title}
        </label>
      </Link>
      <div
        className={classNames(styles.subPathsList, "w-full justify-between")}
      >
        {subPaths?.map((subPath: SideBarItemPathType, index: number) => {
          return <SubPath key={index} subPath={subPath} />;
        })}
      </div>
    </>
  );
};

const SubPath = ({ subPath }: any) => {
  const location = useLocation();

  const [isActivePath, setIsActivePath] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname === subPath?.path) {
      setIsActivePath(true);
    } else {
      setIsActivePath(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  return (
    <Link
      to={subPath.path ? subPath.path : ""}
      className={classNames(
        isActivePath
          ? styles.activeSubNavItemContainer
          : styles.navItemContainer,
        "w-full pr-3 justify-between"
      )}
    >
      <div className={classNames("flex items-center")}>
        <div className={classNames(styles.icon)} />
        <label className={classNames(styles.heading)} role="button">
          {subPath.title}
        </label>
      </div>
    </Link>
  );
};

export default NavItem;
